import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Variant';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.75C12 3.33579 12.3358 3 12.75 3H20.25C20.6642 3 21 3.33579 21 3.75V14.25C21 14.6642 20.6642 15 20.25 15H16.5V17.25C16.5 17.6642 16.1642 18 15.75 18H12V20.25C12 20.6642 11.6642 21 11.25 21H3.75C3.33579 21 3 20.6642 3 20.25V9.75C3 9.33579 3.33579 9 3.75 9H7.5V6.75C7.5 6.33579 7.83579 6 8.25 6H12V3.75ZM9 9H11.25C11.6642 9 12 9.33579 12 9.75V16.5H15V7.5H9V9ZM19.5 13.5H16.5V6.75C16.5 6.33579 16.1642 6 15.75 6H13.5V4.5H19.5V13.5ZM4.5 19.5V10.5H10.5V19.5H4.5Z" fill="currentColor"/>
  </svg>
`;

const VariantIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3.75C12 3.33579 12.3358 3 12.75 3H20.25C20.6642 3 21 3.33579 21 3.75V14.25C21 14.6642 20.6642 15 20.25 15H16.5V17.25C16.5 17.6642 16.1642 18 15.75 18H12V20.25C12 20.6642 11.6642 21 11.25 21H3.75C3.33579 21 3 20.6642 3 20.25V9.75C3 9.33579 3.33579 9 3.75 9H7.5V6.75C7.5 6.33579 7.83579 6 8.25 6H12V3.75ZM9 9H11.25C11.6642 9 12 9.33579 12 9.75V16.5H15V7.5H9V9ZM19.5 13.5H16.5V6.75C16.5 6.33579 16.1642 6 15.75 6H13.5V4.5H19.5V13.5ZM4.5 19.5V10.5H10.5V19.5H4.5Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: VariantIcon,
  IconSvg: IconSvg
} as IconType;
